module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.vocabCurrent) ? _c('VocabCardQuestion', {
    key: _vm.vocabCurrent.id,
    attrs: {
      "vocab": _vm.vocabCurrent
    }
  }) : (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n\tLOADING...\n")]) : (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_c('h1', [_vm._v(_vm._s(_vm.error))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55db1293!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionVocab.vue
// module id = 93
// module chunks = 2